/**
 * 采编中心左侧导航自动定稿
 */
"use strict";
angular.module("leftAutoHeightModule", []).
directive("leftAutoHeight", ["$timeout", "globleParamsSet", "$q", function($timeout, globleParamsSet, $q) {
    return {
        restrict: "A",
        replace: false,
        scope: false,
        link: function(scope, $elem, $attrs) {
            let relElement;
            let promise;
            globleParamsSet.domObserver($elem[0], {
                attributeFilter: ['style'],
                subtree: true
            }, init);
            resize();
            scope.$on("$destroy",()=>{
                clearTimeout(promise);
            });
            /**
             * [init description] 初始化
             * @return {[type]} [description]
             */
            function init() {
                if (promise) {
                    clearTimeout(promise);
                    promise = null;
                }
                promise = setTimeout(() => {
                    var windowHeight = window.innerHeight;
                    var elemTop = $elem[0].getBoundingClientRect().top;  //$elem.offset().top 会把scrollTop也算进去
                    relElement = $attrs["reElement"] ? $attrs["reElement"].split(",") : [];
                    var relHeight = 0;
                    relElement.forEach(function(item, index) {
                        relHeight += $(item).height();
                    });
                    $elem.css("height", windowHeight - elemTop - relHeight);
                }, 500);
            }
            /**
             * [reElementResize description] 相关元素重置大小计算
             * @return {[type]} [description]
             */
            function reElementResize() {
                if (relElement.length >= 0) {
                    relElement.forEach((item, index) => {
                        let $item = $(item);
                        $item.resize(init);
                    });
                }
            }

            function resize() {
                window.addEventListener("resize", init);
                scope.$on("$destroy", function() {
                    window.removeEventListener("resize", init);
                })

            }
        }
    };
}]);